import React from 'react';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { FormGroup, FormLabel } from "react-bootstrap";
import { employeesService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";

class EmployeeSeparatedRestEdit extends React.Component {
  employeeSelectFetchOptions = { enabled: true };

  constructor(props) {
    super(props);

    // console.log(props);

    // NOTA: En este caso no hay edit

    this.state = {
      isLoading: false,
      submitted: false,
      employee_id: -1,
      errors: {},
    };
  }


  handleChange = (idOrNull) => {
    this.setState({
      employee_id: idOrNull ? Number(idOrNull) : -1
    });
  }

  checkValidField = (name) => {
    return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
  }

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    const props = this.props;

    const response = await employeesService.addSeparatedRestEmployee(props.employee.id, this.state.employee_id);

    if (response.ok) {
      this.setState({
        isLoading: false,
        errors: {},
      }, () => {

        toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
        props.getSeparatedRestEmployees();
        if (typeof props.onDataChanged === "function") {
          props.onDataChanged();
        }
        props.handleClose();

      });
    }
    else {
      this.setState({
        isLoading: false,
        submitted: true,
        errors: errorFormating(response)
      });
    }
  }

  render() {
    const { employee_id } = this.state;

    return (

      <form onSubmit={this.handleSubmit}>
        <div className="modal-body">
          <FormGroup className="form-group" controlId="employee_id">
            <FormLabel>{this.props.t('common.employee')}</FormLabel>
            <EmployeeSelectSearch
              className="form-select-user"
              controlId="employee_id"
              multiple={false}
              value={employee_id === -1 ? null : String(employee_id)}
              onChange={this.handleChange}
              fetchOptions={this.employeeSelectFetchOptions}
              placeholder={this.props.t('common.selectEmployee')}
              allLabel={this.props.t('common.selectEmployee')}
            />

            {this.checkValidField('employee_id') && (
              <div className="invalid-feedback d-block">
                {this.state.errors.employee_id}
              </div>
            )}
          </FormGroup>

          {this.state.errors && this.state.errors.general && (
            <div
              className="alert alert-danger alert-general-error fade show"
              role="alert"
            >
              {this.state.errors.general}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{this.props.t('common.cancel')}</button>
          <SubmitButton
            type="submit"
            isLoading={this.state.isLoading}
            text={this.props.t('common.save')}
            loadingText={this.props.t('common.saving')}
          />
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state, myProps) => ({
  employee: myProps.employee,
});

export default connect(mapStateToProps)(withTranslation()(EmployeeSeparatedRestEdit));